export function deleteOrganization(id: string): Promise<Response> {
  return fetch(`/v1/organizations/${id}`, {
    method: "DELETE",
  });
}
